import React from 'react';
import Hero from '../Home/Hero';
import "../Home/Home.css";
import Navbar from '../Navbar';
import About from './About';
import RoomsPreview from './RoomsPreview';
import Amenities from './Amenities';
import Testimonials from './Testimonials';
import ContactPreview from './ContactPreview';
const Home = () => {
  return (
    <>
    {/* <Navbar/> */}
      <Hero />
      <RoomsPreview/>
      <About/>
      <Amenities/>
      <Testimonials/>
      <ContactPreview/>
    </>
  );
};

export default Home;